import React from "react";

const Error = () => {
  return (
    <div>
      <p>❌ The URL provided is not valid.</p>
    </div>
  );
};

export default Error;
